import TEXTS from "../../../locale/texts";

export const contactsFromGroupColumns  = function(lang = 'ru') {
  return (
    [
      {
        title: TEXTS.groupNameLabel[lang],
        dataIndex: 'name'
      },
      {
        title: TEXTS.thContactsCount[lang],
        dataIndex: 'contactCount',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.thBlackListCount[lang],
        dataIndex: 'blackContactCount',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.comment[lang],
        dataIndex: 'note',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      }
    ]
  )
};
